import { render, staticRenderFns } from "./trendDetail.vue?vue&type=template&id=dda6161e&scoped=true&"
import script from "./trendDetail.vue?vue&type=script&lang=js&"
export * from "./trendDetail.vue?vue&type=script&lang=js&"
import style0 from "./trendDetail.vue?vue&type=style&index=0&id=dda6161e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda6161e",
  null
  
)

export default component.exports